import XhrAdapter from "./adapters/xhr_adapter";

export default class Ajax {
  static send(options = {}, timeout = 0){
    var xhr, formData;

    xhr = new XhrAdapter({ dataType: options["dataType"] });
    xhr.open(options["method"], options["url"]);

    if (options["headers"]) {
      for(let key in options["headers"]){
        xhr.setRequestHeader(key, options["headers"][key]);
      }
    }

    xhr.timeout(timeout);

    if (typeof options["done"]  === "function")
      xhr.onDone(options["done"]);
    if (typeof options["success"] === "function")
      xhr.onSuccess(options["success"]);
    if (typeof options["error"] === "function")
      xhr.onError(options["error"]);
    if (options["formData"] != undefined )
      formData = options["formData"];


    xhr.send(formData);
  }

  static get(options = {}){
    options.method = "GET";
    Ajax.send(options);
  }

  static getJSON(options = {}){
    options.dataType = "json";
    Ajax.get(options);
  }

  static post(options = {}){
    options.method = "POST";
    Ajax.send(options);
  }

  static postJSON(options = {}){
    options.dataType = "json";
    Ajax.post(options);
  }

}
